var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ItemCoordinateControl" }, [
    _c("div", { staticClass: "ItemCoordinateControl_Label" }, [
      _c("a", [_vm._v(" " + _vm._s(_vm.coordinateKey) + ": ")])
    ]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        staticClass: "ItemCoordinateControl_Input",
        attrs: { type: "number", min: "0", max: "10000", readonly: "readonly" },
        domProps: { value: _vm.coordinateValue }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }